import './index.css';
import React from 'react';

const getScrollableParent = (node) => {
    if (node == null) {
        return null;
    }
    if (node.scrollHeight > node.clientHeight) {
        return node;
    }
    return getScrollableParent(node.parentElement);
};
const shouldShowDividerOrProgress = ({ type, showDivider, showProgress, isScrollEnd, }) => {
    const shouldShowProgress = type === 'mobile' ? false : React.isValidElement(showProgress);
    if (shouldShowProgress) {
        return {
            shouldShowProgress,
            shouldShowDivider: false,
        };
    }
    const shouldShowDivider = typeof showDivider === 'boolean' ? showDivider : !isScrollEnd;
    return {
        shouldShowProgress: false,
        shouldShowDivider,
    };
};

export { getScrollableParent, shouldShowDividerOrProgress };
//# sourceMappingURL=utils.js.map
